class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;
    const sectionId = this.dataset.sectionId;
    const limit = this.dataset.limit;
    fetch(
      `/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limit}`
    ).then((res) => res.text()).then((html) => {
      this.innerHTML = html;
    });
  }
}
customElements.define("product-recommendations", ProductRecommendations);
